import React from 'react';
import { Box, Flex, Text, Image, Container } from 'theme-ui';
import { navigate } from 'gatsby';
import styles from './styles';
import knowledgeBaseImg from '../../../../../targpatrol-en/content/assets/flexiblocks/shared/our-knowledge-base.svg';
import youtubeChannelImg from '../../../../../targpatrol-en/content/assets/flexiblocks/shared/youtube-channel.svg';
import ourBlogImg from '../../../../../targpatrol-en/content/assets/flexiblocks/shared/our-blog.svg';
import chevronImg from '../../../../../targpatrol-en/content/assets/flexiblocks/icons/chevron-right.svg'


const resources = [
  {
    title: 'Our Knowledge Base',
    description: 'We\'ve created a Knowledge Base to make working with the system easier for you.',
    image: knowledgeBaseImg,
    link: '/knowledge-base',
  },
  {
    title: 'Our YouTube Channel',
    description: 'Find all the essential materials for a quick start and system setup.',
    image: youtubeChannelImg,
    link: 'https://www.youtube.com/@targpatrol',
  },
  {
    title: 'Our Blog',
    description: 'Discover useful tips and successful case studies.',
    image: ourBlogImg,
    link: '/blog',
  }
];

const HelpfulResources = () => {
  return (
    <Container sx={styles.containerStyles}>
      <Text as="h2" sx={styles.textStyles.title}>Helpful Resources</Text>
      <Flex sx={{ justifyContent: 'center', gap: '30px', flexWrap: 'wrap' }}>
        {resources.map((resource, index) => (
          <Flex
            key={`resource-${index}`}
            sx={styles.cardWrapper}
            onClick={() => navigate(resource.link)}
          >
            <Box sx={styles.cardStyle}>
              <Box sx={styles.imageWrapperStyles}>
                <Image src={resource.image} alt={resource.title} sx={{ mt: '7px' }} />
              </Box>
              <Box sx={styles.textStyles.subtitle}>{resource.title}</Box>
              <Text sx={styles.textStyles.description}>{resource.description}</Text>
              <Flex sx={styles.linkStyles}>
                <Text>READ MORE</Text>
                <Image src={chevronImg} sx={{ ml: '8px' }} />
              </Flex>
            </Box>
          </Flex>
        ))}
      </Flex>
    </Container>
  );
};

export default HelpfulResources;
